import { Box, Flex, Text, useToast } from '@chakra-ui/react';
import { Link, useParams } from 'react-router';

import { ROLE_ENUM } from '@/const/role';
import { useTenant } from '@/hooks/use-tenant';
import { useUser } from '@/lib/auth';

export const NavigationMenu = () => {
  console.info('navigation-menu.tsx_1');

  const toast = useToast();
  const tenantId = useTenant().tenantId;
  const { tenantSlug, documentId } = useParams();
  const user = useUser();
  const role = user?.data?.role_id;

  const navigation =
    role == ROLE_ENUM.ADMIN || role == ROLE_ENUM.SECRETARIAT
      ? // システム運用者または議会事務局の場合
        [
          {
            to: [`/${tenantSlug}/app/document`, `/${tenantSlug}/app/document/`],
            name: '署名データ一覧',
          },
          {
            to: [
              `/${tenantSlug}/app/document/create`,
              `/${tenantSlug}/app/document/create/`,
              `/${tenantSlug}/app/document/create/file`,
              `/${tenantSlug}/app/document/create/file/`,
              `/${tenantSlug}/app/document/create/attribute`,
              `/${tenantSlug}/app/document/create/attribute/`,
              `/${tenantSlug}/app/document/create/signer`,
              `/${tenantSlug}/app/document/create/signer/`,
              `/${tenantSlug}/app/document/create/position`,
              `/${tenantSlug}/app/document/create/position/`,
              `/${tenantSlug}/app/document/create/confirm`,
              `/${tenantSlug}/app/document/create/confirm/`,
            ],
            name: '署名データ登録',
          },
        ]
      : // 議員の場合
        [
          {
            to: [`/${tenantSlug}/app/document`, `/${tenantSlug}/app/document/`],
            name: '署名データ一覧',
          },
        ];

  if (role === ROLE_ENUM.ADMIN || role === ROLE_ENUM.SECRETARIAT) {
    console.info('navigation-menu.tsx_2');
    navigation.push({
      to: [`/${tenantSlug}/app/user`, `/${tenantSlug}/app/user/`],
      name: 'ユーザー管理',
    });
    if (role === ROLE_ENUM.ADMIN) {
      console.info('navigation-menu.tsx_3');
      navigation.push({
        to: [`/${tenantSlug}/app/tenant`, `/${tenantSlug}/app/tenant/`],
        name: 'テナント管理',
      });
    }
    console.info('navigation-menu.tsx_4');
  }
  console.info('navigation-menu.tsx_5');

  const selectTenantToast = () => {
    console.info('navigation-menu.tsx_6');

    toast({
      title: 'テナントを選択してください',
      status: 'error',
      duration: 3000,
      isClosable: true,
    });
  };

  return (
    <Box w="10vw" py={3} bgColor="blue.50" shadow={{ base: 'lg' }}>
      {navigation.map((item, index) => {
        // 署名データ詳細画面の場合は署名データ一覧を選択状態にする
        const isCurrent = documentId
          ? item.name == '署名データ一覧'
          : item.to.includes(location.pathname);
        return (
          <div key={index}>
            <Box>
              {tenantId ? (
                <Link to={item.to[0]}>
                  <Flex
                    px={4}
                    py={2}
                    align="center"
                    color={isCurrent ? 'white' : 'black'}
                    bg={isCurrent ? 'blue.300' : 'transparent'}
                    _hover={{ bg: 'gray.200', color: 'black' }}
                    fontWeight="500"
                  >
                    <Text ml={3}>{item.name}</Text>
                  </Flex>
                </Link>
              ) : (
                <Box onClick={() => selectTenantToast()}>
                  <Flex
                    px={4}
                    py={2}
                    align="center"
                    color="black"
                    bg="transparent"
                    _hover={{ bg: 'gray.200', color: 'black' }}
                    fontWeight="500"
                  >
                    <Text ml={3}>{item.name}</Text>
                  </Flex>
                </Box>
              )}
            </Box>
          </div>
        );
      })}
    </Box>
  );
};
